import { Box } from '@zoopla-eng/zds/box';
import { ButtonLink } from '@zoopla-eng/zds/button';
import { FC } from 'react';

export type Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodeData: Record<string, any>;
};

const ButtonEntry: FC<React.PropsWithChildren<Props>> = ({ nodeData }) => {
    return (
        <Box pb="S500">
            <ButtonLink
                href={nodeData?.['data'].target.fields.buttonUrl}
                category={nodeData?.['data'].target.fields.category}
                data-type={nodeData?.['data'].target.fields.category}
                title={nodeData?.['data'].target.fields.buttonLabel}
                aria-label={nodeData?.['data'].target.fields.buttonLabel}
            >
                {nodeData?.['data'].target.fields.buttonLabel}
            </ButtonLink>
        </Box>
    );
};

export default ButtonEntry;
